import { NavDrawerProps } from '@procureai/ui-mui';
import { Route, Routes } from 'react-router-dom';

import { NavId } from '~/common/types';
import { NavDrawerSimple } from '~/components/NavDrawerSimple/NavDrawerSimple';
import { AnalyticsDrawer } from '~/routes/Analytics/Analytics.drawer';
import { DataFoundationDrawer } from '~/routes/DataFoundation/DataFoundation.drawer';
import { RiskSustainabilityDrawer } from '~/routes/experiments/RiskSustainability/RiskSustainability.drawer';
import { IntakeListDrawer } from '~/routes/IntakeList/IntakeList.drawer';
import { InternalToolsDrawer } from '~/routes/InternalTools/InternalTools.drawer';
import { NegotiationDemandListDrawer } from '~/routes/NegotiationDemandList/NegotiationDemandList.drawer';
import { RouteId } from '~/routes/RouteId';
import { SettingsDrawer } from '~/routes/Settings/Settings.drawer';
import { TeamManagementDrawer } from '~/routes/TeamManagement/TeamManagement.drawer';
import { UserAvailabilityListDrawer } from '~/routes/UserAvailabilityList/UserAvailabilityList.drawer';
import { UserProfileDrawer } from '~/routes/UserProfile/UserProfile.drawer';

export const AppNavDrawer = (props: NavDrawerProps) => {
  // if drawer is pinned we need to add an empty drawer for each main route
  // because the actual page content is padded with the width of the drawer
  const fallbackDrawers = props.pinned ? (
    <>
      <Route path={RouteId.analyticsAll} element={<NavDrawerSimple navId={NavId.analytics} {...props} />} />
      <Route path={RouteId.dataFoundationAll} element={<NavDrawerSimple navId={NavId.dataFoundation} {...props} />} />
      <Route path={RouteId.negotiationAll} element={<NavDrawerSimple navId={NavId.negotiation} {...props} />} />
      <Route path={RouteId.customDataAll} element={<NavDrawerSimple navId={NavId.cmdi} {...props} />} />
      <Route path={RouteId.intakeAll} element={<NavDrawerSimple navId={NavId.intake} {...props} />} />
      <Route path={RouteId.team} element={<NavDrawerSimple navId={NavId.team} {...props} />} />
      <Route path={RouteId.teamManagement} element={<NavDrawerSimple navId={NavId.teamManagement} {...props} />} />
      <Route path={RouteId.settingsAll} element={<NavDrawerSimple navId={NavId.settings} {...props} />} />
      <Route
        path={RouteId.riskSustainabilityAll}
        element={<NavDrawerSimple navId={NavId.riskSustainability} {...props} />}
      />
      <Route path={RouteId.internalToolsAll} element={<NavDrawerSimple navId={NavId.internalTools} {...props} />} />

      <Route path="*" element={<NavDrawerSimple {...props} />} />
    </>
  ) : (
    // include an empty catch-all route, otherwise we'll get console warnings
    <Route path="*" element={null} />
  );

  return (
    <Routes>
      <Route path={RouteId.userProfile('')} element={<UserProfileDrawer {...props} />} />
      <Route path={RouteId.dataFoundationAll} element={<DataFoundationDrawer {...props} />} />
      <Route path={RouteId.demandAll} element={<NegotiationDemandListDrawer {...props} />} />
      <Route path={RouteId.intakeAll} element={<IntakeListDrawer {...props} />} />
      <Route path={RouteId.team} element={<UserAvailabilityListDrawer {...props} />} />
      <Route path={RouteId.teamManagement} element={<TeamManagementDrawer {...props} />} />
      <Route path={RouteId.analyticsAll} element={<AnalyticsDrawer {...props} />} />
      <Route path={RouteId.riskSustainabilityAll} element={<RiskSustainabilityDrawer {...props} />} />
      <Route path={RouteId.settingsAll} element={<SettingsDrawer {...props} />} />
      <Route path={RouteId.internalToolsAll} element={<InternalToolsDrawer {...props} />} />
      {fallbackDrawers}
    </Routes>
  );
};
